export const pdfImageReducer = (state, action) => {
	switch (action.type) {
		case 'SET_PDF_IMG':
			return action.pdfimg
		default:
			return state
	}
}